import * as React from 'react';

import { ToolName } from '../types';

import { DefaultToolCall, ToolCallProps } from './DefaultToolCall';
import { SaveStudyToolCall } from './SaveStudyToolCall';
import { UpdateStudyToolCall } from './UpdateStudyToolCall';

const TOOL_COMPONENTS: Partial<Record<ToolName, React.ComponentType<ToolCallProps>>> = {
  greatquestion_create_unmoderated_study_tool: SaveStudyToolCall,
  greatquestion_create_moderated_study_tool: SaveStudyToolCall,
  save_draft_study_to_scratchpad: UpdateStudyToolCall
};

export const ToolCall: React.FC<ToolCallProps> = ({ toolInvocation, message, openContent }) => {
  const ToolComponent = TOOL_COMPONENTS[toolInvocation.toolName] || DefaultToolCall;

  return React.createElement(ToolComponent, { toolInvocation, message, openContent });
};

export { DefaultToolCall } from './DefaultToolCall';
export { UpdateStudyToolCall } from './UpdateStudyToolCall';
